import {Component,OnInit} from "@angular/core";
import {Router} from "@angular/router";
import {Axe6DTO} from "@domain/admin/entreprise/analytique/axe6Dto";
import {ListViewItem} from "@domain/common/list-view/list-view-item";
import {TranslateService} from "@ngx-translate/core";

/**
 * Composant d'affichage d'un référentiel Axe 6 dans la liste de tous les référentiels
 */
@Component({
    host: {'data-test-id': 'analytique-axe6-item'},
    selector: 'analytique-axe6-item',
    templateUrl: './analytique-axe6-item.component.html'
})
export class AnalytiqueAxe6ItemComponent extends ListViewItem<Axe6DTO> implements OnInit{
    /** Liste des types de filtre présents */
    filtres: string;

    /**
     * Constructeur
     *
     * @param translateService Service de traduction
     * @param router Router de l'application
     */
    constructor(
        private translateService: TranslateService,
        private router: Router
    ) {
        super();
    }

    /**
     * Initialisation
     */
    ngOnInit() {
        //Initialisation de la liste des filtres
        let listeFiltres = new Array<String>();

        if (this.data.filtreDossier) { listeFiltres.push(this.translateService.instant('admin.entreprise.analytique.axe6.infos.filtre.cc')); }
        if (this.data.filtreAxe5) { listeFiltres.push(this.translateService.instant('admin.entreprise.analytique.axe6.infos.filtre.eotp')); }
        if (this.data.filtreMotCle) { listeFiltres.push(this.translateService.instant('admin.entreprise.analytique.axe6.infos.filtre.mc')); }
        if (this.data.filtreOrga) { listeFiltres.push(this.translateService.instant('admin.entreprise.analytique.axe6.infos.filtre.se')); }
        if (this.data.filtreTypeEntite) { listeFiltres.push(this.translateService.instant('admin.entreprise.analytique.axe6.infos.filtre.te')); }

        //Initialisation de la string à afficher
        this.filtres = listeFiltres.join(', ')
        listeFiltres.length = 0;
    }

    /**
     * Méthode appelée lors de la sélection d'un référentiel Axe 6
     */
    onSelect() {
        //Navigation vers la page d'informations du référentiel
        this.router.navigate(['Admin/Entreprise/Analytique/Axe6/' + this.data.idAxe6]);
    }
}